import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/attendance";

export default {
    /** 获取考勤统计结果列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/queryListCount`, data: data}),
    /** 考勤明细*/
    queryListDetail: (data) => axios.get({url: `${PREFIX_URI}/queryListDetail`, data: data}),

    /** 查询详情列表 */
    listDetail: (data) => axios.get({url: `${PREFIX_URI}/listDetail`, data: data}),

    /**  查询人员详情列表 */
    listWorkerDetail: (data) => axios.get({url: `${PREFIX_URI}/listWorkerDetail`, data: data}),

    /** 查询考勤视频列表 */
    listAttendanceVideo: (data) => axios.get({url: `${PREFIX_URI}/video/listAttendanceVideo`, data: data}),

    /** 保存表单配置 */
    saveVideoFormConfig: (data) => axios.post({url: `${PREFIX_URI}/video/saveVideoFormConfig`, data: data}),

    /** 查询表单配置 */
    listVideoFormConfig: () => axios.get({url: `${PREFIX_URI}/video/listVideoFormConfig`}),

    /** 查询详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/video/findById`, data: {id}}),

    /** 审查 */
    videoReview: (data) => axios.post({url: `${PREFIX_URI}/video/videoReview`, data: data}),
    /** 其它类型的考勤数据 */
    queryListCountOther: (data) => axios.get({url: `${PREFIX_URI}/queryListCountOther`, data: data}),
    /**打卡的具体时间*/
    getAttendanceToday: (data) => axios.get({url: `${PREFIX_URI}/getAttendanceToday`, data: data}),
}
